export default __webpack_public_path__ + "static/media/party.460d31e5.png";